module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "fron_1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmha"
  }, [_c('strong', [_vm._v("PRAISE FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1a"
  }, [_c('strong', [_vm._v("AMANDA SCOTT’S")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2a"
  }, [_c('strong', [_vm._v("SCOTTISH ADVENTURES")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2a"
  }, [_c('em', [_c('strong', [_vm._v("LADY’S CHOICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“"), _c('em', [_vm._v("Lady’s Choice")]), _vm._v(" is terrific . . . with an exhilarating climax that sets up the next [book] in this high-quality series. Scott is at the top of her game with this deep historical tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—Harriet Klausner, "), _c('em', [_vm._v("Midwest Book Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Enjoyable . . . The premise of Scott’s adventure romance is strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—Kathe Robin, "), _c('em', [_vm._v("Romantic Times"), _c('br'), _vm._v(" BOOKclub Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A page-turner . . . Scott has done good research, and with realistic dialogue, her characters are a joy to read. "), _c('em', [_vm._v("Lady’s Choice")]), _vm._v(" is sure to delight medieval historical fans.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Romance Reviews Today")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Plenty of suspense and action and a delightful developing love story . . . Another excellent story from Scott.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReviewsMag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "fm2a"
  }, [_c('em', [_c('strong', [_vm._v("PRINCE OF DANGER")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Excellently written, well researched, and entertaining . . . A fascinating story.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—HistoricalRomanceWriters.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Phenomenal.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('em', [_c('strong', [_vm._v("—Romantic Times BOOKclub Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“RITA Award–winning Scott has a flair for colorful, convincing characterization.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Exhilarating . . . fabulous . . . action-packed . . . Fans of fast-paced historical tales starring an intrepid heroine and a courageous champion will want to read Amanda Scott’s latest.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Midwest Book Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Exciting . . . so good.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReviewsMag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Amanda Scott is a phenomenal writer . . . I am not sure if perfection can be improved upon, but that is exactly what she has done in her latest offering.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReaderAtHeart.com")])]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "fm2a"
  }, [_c('em', [_c('strong', [_vm._v("LORD OF THE ISLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Ms. Scott’s diverse, marvelous, unforgettable characters in this intricate plot provide hours of pure pleasure.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Rendezvous")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Scott pits her strong characters against one another and fate. She delves into their motivations, bringing insight into them and the thrilling era in which they live.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Romantic Times BOOKclub Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Amanda Scott writes great tales [set] during this turbulent time in Scotland’s history.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReviewsMag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Ms. Scott’s storytelling is amazing and she has created a captivating tale of intrigue. She had me riveted to my chair throughout the book . . . This is a definite keeper.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—CoffeeTimeRomance.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Has all of the elements that I like in a book . . . It is a fast-paced and smooth read, and put a smile on my face more than once while I was reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReaderAtHeart.com")])]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "fm2a"
  }, [_c('em', [_c('strong', [_vm._v("HIGHLAND PRINCESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Fast-moving, exciting, and soaring to heights of excellence, this one is a winner.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Rendezvous")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Delightful historical starring two fabulously intelligent lead characters . . . Grips the audience from the onset and never [lets] go.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Affaire de Coeur")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Perfect for readers who enjoy romances with a rich sense of history.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Booklist")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A fabulous medieval Scottish romance.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Midwest Book Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A marvelously rendered portrait of medieval Scotland, terrific characters, and a dynamic story.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—"), _c('em', [_vm._v("Romantic Times BOOKclub Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Great mix of romance, adventure, humor, courage, and passion—a very captivating read. One can almost hear the bagpipes playing . . . a MUST read.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—TheBestReviews.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Powerful . . . so exciting! Wonderful! Loved it.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanticReviewsMag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Irresistible! . . . Passion, danger, and even a murder mystery are intertwined to create constant intrigue.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—BookLoons.com")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“As usual, the author has created a very believable set of characters, a vivid setting, and a wonderful love story.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_c('strong', [_vm._v("—RomanceReadersConnection.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a67f8342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofStorms_fron_1.vue
// module id = 66
// module chunks = 0